<app-page-header></app-page-header>
<app-breadcromb pageName="Reset Password"></app-breadcromb>
<!-- Login Area Start -->
<section class="jobguru-login-area section_70">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="login-box">
          <div class="login-title">
            <h3>Reset Password</h3>
          </div>
          <div *ngIf="!d.token.touched" class="alert alert-success mt-3 mb-0">We sent a 6 digit code to your email, please copy the code.</div>
          <form [hidden]="success" [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()">
            <div class="single-login-field">
              <input type="text" formControlName="token" placeholder="6 digit CODE">
              <div class="text-danger" *ngIf="d.token.touched && d.token.invalid">
                <span *ngIf="d.token.errors.required">Password reset code is required</span>
                <span *ngIf="d.token.errors.minlength">Invalid code</span>
                <span *ngIf="d.token.errors.maxlength">Invalid code</span>
              </div>
            </div>
            <div class="single-login-field">
              <input type="password" formControlName="password" placeholder="Enter New Password">
              <div class="text-danger" *ngIf="d.password.touched && d.password.invalid">
                <span *ngIf="d.password.errors.required">Password is required</span>
                <span *ngIf="d.password.errors.minlength">Password should be at least 8 characters</span>
              </div>
            </div>
            <div class="single-login-field">
              <input type="password" formControlName="password_confirmation" placeholder="Confirm New Password">
              <div class="text-danger" *ngIf="d.password_confirmation.touched && d.password_confirmation.invalid">
                <span *ngIf="d.password_confirmation.errors.required">Password confirmation is a required field</span>
                <span *ngIf="d.password_confirmation.errors.passwordMisMatch">Password do not match</span>
              </div>
            </div>
            <div class="single-login-field">
              <button [disabled]="resetPasswordForm.invalid" type="submit" class="btn btn-primary btn-xs">
                <span *ngIf="!resettingPassword">Reset Password</span>
                <span *ngIf="resettingPassword">Please wait...</span>
              </button>
            </div>
          </form><div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
          <div *ngIf="success" class="alert alert-success mt-3 mb-0">{{success}}</div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Login Area End -->
